/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetPersonCategoryTreeParams,
  SimplePersonCategory
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPersonCategoriesUrl = () => {




  return `/api/PersonCategory/GetPersonCategories`
}

export const getPersonCategories = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimplePersonCategory[]> => {

  return customInstance<SimplePersonCategory[]>(getGetPersonCategoriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonCategoriesQueryKey = () => {
    return [
    `/api/PersonCategory/GetPersonCategories`
    ] as const;
    }


export const getGetPersonCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonCategories>>> = ({ signal }) => getPersonCategories({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonCategories>>>
export type GetPersonCategoriesQueryError = ErrorType<unknown>


export function useGetPersonCategories<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCategories>>,
          TError,
          Awaited<ReturnType<typeof getPersonCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategories<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCategories>>,
          TError,
          Awaited<ReturnType<typeof getPersonCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategories<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonCategories<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonCategories>>> = ({ signal }) => getPersonCategories({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonCategories>>>
export type GetPersonCategoriesSuspenseQueryError = ErrorType<unknown>


export function useGetPersonCategoriesSuspense<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoriesSuspense<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoriesSuspense<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonCategoriesSuspense<TData = Awaited<ReturnType<typeof getPersonCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonCategoryTreeUrl = (params?: GetPersonCategoryTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/PersonCategory/GetPersonCategoryTree?${stringifiedParams}` : `/api/PersonCategory/GetPersonCategoryTree`
}

export const getPersonCategoryTree = async (params?: GetPersonCategoryTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetPersonCategoryTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonCategoryTreeQueryKey = (params?: GetPersonCategoryTreeParams,) => {
    return [
    `/api/PersonCategory/GetPersonCategoryTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonCategoryTreeQueryOptions = <TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonCategoryTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonCategoryTree>>> = ({ signal }) => getPersonCategoryTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonCategoryTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonCategoryTree>>>
export type GetPersonCategoryTreeQueryError = ErrorType<unknown>


export function useGetPersonCategoryTree<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonCategoryTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCategoryTree>>,
          TError,
          Awaited<ReturnType<typeof getPersonCategoryTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoryTree<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonCategoryTree>>,
          TError,
          Awaited<ReturnType<typeof getPersonCategoryTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoryTree<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonCategoryTree<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonCategoryTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonCategoryTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonCategoryTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonCategoryTree>>> = ({ signal }) => getPersonCategoryTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonCategoryTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonCategoryTree>>>
export type GetPersonCategoryTreeSuspenseQueryError = ErrorType<unknown>


export function useGetPersonCategoryTreeSuspense<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonCategoryTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoryTreeSuspense<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonCategoryTreeSuspense<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonCategoryTreeSuspense<TData = Awaited<ReturnType<typeof getPersonCategoryTree>>, TError = ErrorType<unknown>>(
 params?: GetPersonCategoryTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonCategoryTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonCategoryTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






